import { render, staticRenderFns } from "./TabelaPecas.vue?vue&type=template&id=764214a6&"
import script from "./TabelaPecas.vue?vue&type=script&lang=ts&"
export * from "./TabelaPecas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports